import { PageLoading } from "@ant-design/pro-layout";
import { ErrorBoundary } from "@ant-design/pro-utils";
import { useStore } from "contexts";
import { FC, Suspense, lazy } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import dashboardRoutes from "routes/dashboard";
import { IRoute } from "./types";

const DashboardLayout = lazy(() => import("layouts"));
const NotAuthorized = lazy(() => import("pages/exceptions/NotAuthorized"));
const NotFound = lazy(() => import("pages/exceptions/NotFound"));

const MainRoutes: FC = () => {
  const location = useLocation();
  const [{ authorized }] = useStore();

  const routes: IRoute[] = [
    {
      path: "/403",
      key: "not_authorized",
      component: <NotAuthorized />,
    },
    {
      key: "not_found",
      path: "*",
      component: <NotFound />,
    },
  ];

  if (authorized) {
    routes.push({
      path: "/dashboard",
      key: "dashboard",
      component: <DashboardLayout />,
      children: dashboardRoutes,
    });
  }

  return (
    <TransitionGroup>
      <CSSTransition key={location.key} classNames="fade" timeout={300}>
        <Routes location={location}>
          <Route
            key="root"
            path="/"
            element={<Navigate to={"/dashboard/ads"} />}
          />
          {routes.map((route) =>
            !route.children ? (
              <Route
                key={route.key}
                path={route.path}
                element={
                  <ErrorBoundary>
                    <Suspense fallback={<PageLoading />}>
                      {route.component}
                    </Suspense>
                  </ErrorBoundary>
                }
              />
            ) : (
              <Route
                key={route.key}
                path={route.path}
                element={
                  <ErrorBoundary>
                    <Suspense fallback={<PageLoading />}>
                      {route.component}
                    </Suspense>
                  </ErrorBoundary>
                }
              >
                {route.children.map((item) => (
                  <Route
                    key={item.key}
                    path={item.path}
                    element={
                      <ErrorBoundary>
                        <Suspense fallback={<PageLoading />}>
                          {item.component}
                        </Suspense>
                      </ErrorBoundary>
                    }
                  />
                ))}
              </Route>
            )
          )}
        </Routes>
      </CSSTransition>
    </TransitionGroup>
  );
};

export default MainRoutes;
